module.exports = __webpack_public_path__ + "img/occupation_story_card3.bcfc72c7.svg";